/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_506Inputs */

const vi_carrier_status_506 = /** @type {(inputs: Carrier_Status_506Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát thất bại`)
};

/**

* @param {Carrier_Status_506Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_506 = /** @type {((inputs?: Carrier_Status_506Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_506Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_506(inputs)
});